// extracted by mini-css-extract-plugin
module.exports = {"cards":"style_cards__xrmk2"};